import type { ApiBrowseHistoryItem, ApiPlayable, CursorPaginated } from "@hive/sdk";

/** Web's History and Recently played share browse history; CMS PLAY_HISTORY uses actual plays separately. */
export async function loadRecentGameHistory(
	read: (cursor?: string) => Promise<CursorPaginated<ApiBrowseHistoryItem>>,
	cursor?: string,
	isCurrent = () => true,
): Promise<CursorPaginated<ApiPlayable>> {
	const visited = new Set<string | undefined>();
	while (true) {
		visited.add(cursor);
		const page = await read(cursor);
		// Do not follow another private cursor after the viewer or selected feed changes.
		if (!isCurrent()) return { items: [], meta: { nextCursor: null, hasMore: false } };
		const seen = new Set<string>();
		const items = page.items.flatMap(({ playable }) => {
			if (playable.kind !== "game" || seen.has(playable.id)) return [];
			seen.add(playable.id);
			return [playable];
		});
		if (items.length || !page.meta.hasMore) return { items, meta: page.meta };
		// A page of dramas is not an empty game history. Continue to the first game page.
		const next = page.meta.nextCursor;
		if (!next || visited.has(next)) throw new Error("History pagination did not advance");
		cursor = next;
	}
}
